import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';


export default class GatewayBillingService {
    static getAccountBillingSummary(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getAccountBillingDetails', [accountNumber], additionalHeaders);
    }

    static getAccountBillingSummaryData(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getAccountBillingSummary', [accountNumber], additionalHeaders);
    }

    static getPaymentGroupPaymentInformation(accountNumber, streamInternalId,
        additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getPaymentGroupPaymentInformation', [accountNumber, streamInternalId], additionalHeaders);
    }

    static setPaymentGroupPaymentInformation(accountNumber, streamInternalId, paymentMethod,
        additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'setPaymentGroupPaymentInformation', [accountNumber, streamInternalId, paymentMethod], additionalHeaders);
    }

    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    /**
     * getAccountPaymentInstruments
     * @param {*} additionalHeaders
     */
    static getAccountPaymentInstruments(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
        'getAccountPaymentInstruments',[accountNumber], additionalHeaders);
    }

    static searchBankInstitute_EY(instNumber,bankName,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
        'searchBankInstitute_EY',[instNumber,bankName], additionalHeaders);
    }

    static getURL_EY(mode,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
        'getURL_EY',[mode], additionalHeaders);
    }

    static getBillingDocumentsForBroker(brokerCode, additionalHeaders={}){
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getBillingDocumentsForBroker', [brokerCode], additionalHeaders);
    }

    static getDirectBillDocumentsForBroker(brokerCode, additionalHeaders={}){
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getDirectBillDocumentsForBroker', [brokerCode], additionalHeaders);
    }
}
